import type { ReactNode } from 'react'
import { Minus } from 'lucide-react'
import { cn } from '@/utils/cn'

interface SelectionBarProps {
  count: number
  /** Singular noun shown in the label, e.g. "Item" -> "2 Items Selected". */
  noun: string
  onClear: () => void
  /** Bulk actions rendered on the right. */
  children?: ReactNode
  className?: string
}

/** Header bar shown on top of a table while rows are selected. */
export function SelectionBar({
  count,
  noun,
  onClear,
  children,
  className,
}: SelectionBarProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between bg-white border border-[#d6dae1] rounded-t-xl px-4 py-2.5 mb-[-1px]',
        className
      )}
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          aria-label="Clear selection"
          onClick={onClear}
          className="cursor-pointer flex items-center justify-center"
        >
          <Minus className="h-4 w-4 text-primary" />
        </button>
        <span className="text-sm font-semibold text-[#1c1c1c]">
          {count} {count === 1 ? noun : `${noun}s`} Selected
        </span>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  )
}
